import { render, staticRenderFns } from "./PartOfView.vue?vue&type=template&id=1000fe40&"
import script from "./PartOfView.vue?vue&type=script&lang=js&"
export * from "./PartOfView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports